import Button from 'components/Button';
import React, { useEffect } from 'react';
import { toast } from 'react-toastify';
import styles from './AuthenticationForm.module.css';

export function AuthenticationForm({ children, ctaName, lazyRequest: { sendRequest, isLoading, error } }: any) {
  useEffect(() => {
    const errorMessage = error?.message?.replace(/GraphQL error:/g, '');
    if (errorMessage) {
      toast.error(errorMessage || 'Sorry, something went wrong', { position: 'bottom-center' });
    }
  }, [error]);

  return (
    <form onSubmit={sendRequest}>
      {children}
      <Button className={styles['submit']} type="submit" size="large" disabled={isLoading}>
        {ctaName}
      </Button>
    </form>
  );
}
